
import { ModuleWithProviders }  from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// component nicht über index laden, ergibt runtime fehler
import { LoginComponent } from './login/login.component';
import { orderRoutes } from './orders/index';
import { inventoryRoutes } from './inventory/index';
import { packagingRoutes } from './packaging/index';
import { storagePlaceRoutes } from './storage-place/index';
import { clientInventoryRoutes } from './client-inventory';
import { HomeComponent } from './home/home.component';
import { FeesComponent } from './fees/fees.component';
import { PasswordChangeComponent } from './password-change/password-change.component';
import { AuthGuard } from './services/index';

export const routes: Routes = [
    { path: '', component: HomeComponent, canActivate: [AuthGuard] },
    { path: 'fees', component: FeesComponent, canActivate: [AuthGuard] },
    { path: 'login', component: LoginComponent },
    { path: 'pwdChange', component: PasswordChangeComponent, canActivate: [AuthGuard] },
    ...orderRoutes,
    ...inventoryRoutes,
    ...packagingRoutes,
    ...storagePlaceRoutes,
    ...clientInventoryRoutes,
    // otherwise redirect to home
    { path: '**', redirectTo: '' },
    
];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes);



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/app.routes.ts